(function (global) {
  'use strict';

  var POLICY_SELECTOR = 'script[data-the-faith-multibuy-policy]';
  var CART_ALLOCATION_SIGNATURE = {
    schemaVersion: 1,
    messageTemplate: 'The Faith multi-buy {percentage}% off'
  };
  var MINIMUM_TIER_COUNT = 1;
  var MAXIMUM_TIER_COUNT = 20;

  function unavailablePolicy() {
    return { state: 'unavailable', tiers: [] };
  }

  function isValidTier(tier) {
    return (
      tier &&
      typeof tier === 'object' &&
      !Array.isArray(tier) &&
      Number.isInteger(tier.minimumQuantity) &&
      tier.minimumQuantity > 0 &&
      typeof tier.percentage === 'number' &&
      Number.isFinite(tier.percentage) &&
      tier.percentage > 0 &&
      tier.percentage <= 100
    );
  }

  function parsePolicy(candidate) {
    var seenMinimumQuantities;
    var normalizedTiers;

    if (
      !candidate ||
      typeof candidate !== 'object' ||
      Array.isArray(candidate) ||
      candidate.schemaVersion !== 1 ||
      typeof candidate.enabled !== 'boolean' ||
      !Array.isArray(candidate.tiers) ||
      candidate.tiers.length < MINIMUM_TIER_COUNT ||
      candidate.tiers.length > MAXIMUM_TIER_COUNT
    ) {
      return unavailablePolicy();
    }

    seenMinimumQuantities = {};
    normalizedTiers = [];

    for (var index = 0; index < candidate.tiers.length; index += 1) {
      var tier = candidate.tiers[index];

      if (!isValidTier(tier) || seenMinimumQuantities[tier.minimumQuantity]) {
        return unavailablePolicy();
      }

      seenMinimumQuantities[tier.minimumQuantity] = true;
      normalizedTiers.push({
        minimumQuantity: tier.minimumQuantity,
        percentage: tier.percentage
      });
    }

    normalizedTiers.sort(function (left, right) {
      return left.minimumQuantity - right.minimumQuantity;
    });

    return {
      state: candidate.enabled ? 'active' : 'disabled',
      schemaVersion: 1,
      enabled: candidate.enabled,
      tiers: normalizedTiers
    };
  }

  function readPolicy() {
    var adapter;
    var parsedPolicy;

    if (!global.document || typeof global.document.querySelector !== 'function') {
      return unavailablePolicy();
    }

    adapter = global.document.querySelector(POLICY_SELECTOR);

    if (!adapter) {
      return unavailablePolicy();
    }

    try {
      parsedPolicy = JSON.parse(adapter.textContent || '');
    } catch (error) {
      return unavailablePolicy();
    }

    return parsePolicy(parsedPolicy);
  }

  function readCartContract() {
    var adapter;
    var candidate;
    var parsedPolicy;
    var signature;

    if (!global.document || typeof global.document.querySelector !== 'function') return null;
    adapter = global.document.querySelector(POLICY_SELECTOR);
    if (!adapter) return null;

    try {
      candidate = JSON.parse(adapter.textContent || '');
    } catch (error) {
      return null;
    }

    parsedPolicy = parsePolicy(candidate);
    signature = candidate && candidate.cartAllocationSignature;
    if (
      !parsedPolicy || parsedPolicy.state !== 'active' || !signature ||
      signature.schemaVersion !== CART_ALLOCATION_SIGNATURE.schemaVersion ||
      signature.messageTemplate !== CART_ALLOCATION_SIGNATURE.messageTemplate
    ) return null;

    return { policy: parsedPolicy, allocationSignature: CART_ALLOCATION_SIGNATURE };
  }

  function formatCartAllocationMessage(percentage) {
    if (typeof percentage !== 'number' || !Number.isFinite(percentage) || percentage <= 0 || percentage > 100) return null;
    return CART_ALLOCATION_SIGNATURE.messageTemplate.replace('{percentage}', String(percentage));
  }

  function isCartAllocation(title, percentage) {
    var expected = formatCartAllocationMessage(percentage);
    return expected !== null && title === expected;
  }

  function isNormalizedPolicy(policy) {
    var previousMinimumQuantity = 0;

    if (
      !policy ||
      (policy.state !== 'active' && policy.state !== 'disabled') ||
      policy.schemaVersion !== 1 ||
      policy.enabled !== (policy.state === 'active') ||
      !Array.isArray(policy.tiers) ||
      policy.tiers.length < MINIMUM_TIER_COUNT ||
      policy.tiers.length > MAXIMUM_TIER_COUNT
    ) {
      return false;
    }

    for (var index = 0; index < policy.tiers.length; index += 1) {
      var tier = policy.tiers[index];

      if (!isValidTier(tier) || tier.minimumQuantity <= previousMinimumQuantity) {
        return false;
      }

      previousMinimumQuantity = tier.minimumQuantity;
    }

    return true;
  }

  function emptyProgress(state, qualifyingPieceCount, piecesRemainingToFirstTier) {
    return {
      state: state,
      qualifyingPieceCount: qualifyingPieceCount,
      currentTier: null,
      nextTier: null,
      piecesRemainingToFirstTier: piecesRemainingToFirstTier,
      piecesRemainingToNextTier: null,
      highestTierUnlocked: false
    };
  }

  function resolveProgress(policy, qualifyingPieceCount) {
    var progress;
    var currentTier = null;
    var nextTier = null;

    if (!isNormalizedPolicy(policy)) {
      return emptyProgress('unavailable', null, null);
    }

    if (!Number.isInteger(qualifyingPieceCount) || qualifyingPieceCount < 0) {
      return emptyProgress(policy.state, null, null);
    }

    if (policy.state === 'disabled') {
      return emptyProgress('disabled', qualifyingPieceCount, 0);
    }

    for (var index = 0; index < policy.tiers.length; index += 1) {
      var tier = policy.tiers[index];

      if (tier.minimumQuantity <= qualifyingPieceCount) {
        currentTier = tier;
      } else {
        nextTier = tier;
        break;
      }
    }

    progress = {
      state: 'active',
      qualifyingPieceCount: qualifyingPieceCount,
      currentTier: currentTier,
      nextTier: nextTier,
      piecesRemainingToFirstTier: Math.max(0, policy.tiers[0].minimumQuantity - qualifyingPieceCount),
      piecesRemainingToNextTier: nextTier ? nextTier.minimumQuantity - qualifyingPieceCount : null,
      highestTierUnlocked: currentTier !== null && nextTier === null
    };

    return progress;
  }

  function calculateSaving(currentSellingPriceCents, percentage) {
    if (
      !Number.isInteger(currentSellingPriceCents) ||
      currentSellingPriceCents < 0 ||
      typeof percentage !== 'number' ||
      !Number.isFinite(percentage) ||
      percentage < 0 ||
      percentage > 100
    ) {
      return 0;
    }

    return Math.round((currentSellingPriceCents * percentage) / 100);
  }

  global.TheFaithMultibuy = {
    readPolicy: readPolicy,
    readCartContract: readCartContract,
    isCartAllocation: isCartAllocation,
    parsePolicy: parsePolicy,
    resolveProgress: resolveProgress,
    calculateSaving: calculateSaving
  };
})(typeof window !== 'undefined' ? window : globalThis);
